/**
 * @file The CameraApi is a property of the ViewportApi and must be used by all corresponding ViewportApis.
 *       It is used for all camera related functionality.
 *
 * @module CameraApiTemplate
 * @author Michael Oppitz
 */

let CameraApi = function (_api, ___refs) {

  const CameraApiInterface = require('../../../interfaces/api/CameraApiInterface');

  let _threeDManager = ___refs.threeDManager,
      _apiResponse = ___refs.apiResponse;

  /**
   * @extends module:CameraApiInterface~CameraApiInterface
   * @lends module:CameraApiTemplate~CameraApi
   */
  class CameraApi extends CameraApiInterface {
    
    constructor() {
      super();

      this.get = this.get.bind(this);

      this.updateAsync = this.updateAsync.bind(this);
      this.animateAsync = this.animateAsync.bind(this);
      this.zoomAsync = this.zoomAsync.bind(this);
      this.resetAsync = this.resetAsync.bind(this);
    }

    /** @inheritdoc */
    get() {
      return _apiResponse(null, _threeDManager.cameraHandler.getPositionAndTarget());
    }


    /** @inheritdoc */
    updateAsync(camera, transition) {
      throw new Error('This API function is not implemented by this viewport.');
    }

    /** @inheritdoc */
    animateAsync(path, transition) {
      throw new Error('This API function is not implemented by this viewport.');
    }

    /** @inheritdoc */
    zoomAsync(scenePaths, transition) {
      throw new Error('This API function is not implemented by this viewport.');
    }

    /** @inheritdoc */
    resetAsync(transition) {
      throw new Error('This API function is not implemented by this viewport.');
    }
  }
  return new CameraApi();
};

module.exports = CameraApi;